import { render, staticRenderFns } from "./OverviewPrint.vue?vue&type=template&id=4b0cd6a4&"
import script from "./OverviewPrint.vue?vue&type=script&lang=js&"
export * from "./OverviewPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports